if (document.images) {
    p = new Image();
    p.src = "/_resources/themes/aklbabys/images/loading.gif";
}

var website = function(url) {
    newwindow = window.open(url, '_blank', '');
    newwindow.focus();
};

var popup = function(url) {
    popupWindow = window.open(url, '_blank', 'location=no,menubar=no,width=720,height=620,toolbar=no,scrollbars=yes,resizable=no');
    popupWindow.focus();
};

var fbpopup = function(url) {
    popupWindow = window.open(url, 'sharer', 'location=no,menubar=no,width=548,height=325,toolbar=no,scrollbars=yes,resizable=no');
    popupWindow.focus();
};

var links = function() {
    $('a').each(function() {
        if ($(this).attr('data-rel') == 'popup') {
            $(this).click(function(event) {
                new popup($(this).attr('href'));
                event.preventDefault();
            });
        } else if ($(this).attr('data-rel') == 'fbpopup') {
            $(this).click(function(event) {
                new fbpopup($(this).attr('href'));
                event.preventDefault();
            });
        }
    });
};

var scrollToDiv = function(element) {
    var offset = element.offset();
    var totalScroll = offset.top;

    $('body,html').animate({
        scrollTop: totalScroll
    }, 500);
};

var sharepopup = function(url) {
    popupWindow = window.open(url, 'sharer', 'location=no,menubar=no,width=548,height=325,toolbar=no,scrollbars=yes,resizable=no');
    popupWindow.focus();
};


$(document).ready(function() {
    var $menu = $("#navigation").mmenu({
        // options
        navbar: false,
        scrollBugFix: {
            fix: true
        },
        extensions: [
            "pagedim"
        ]

    }, {
        // configuration
        offCanvas: {
            clone: true
        }
    });

    var API = $menu.data("mmenu");

    $button = $('<button>').addClass('hamburger hamburger--spin').attr('type', 'button').prepend('<span class="hamburger-box"><span class="hamburger-inner"></span></span>');

    $('body').prepend($button);

    $button.on("click", function() {
        if ($button.hasClass("is-active")) {
            API.close();
        } else {
            API.open();
        }
    });

    API.bind("open:finish", function() {
        $button.addClass("is-active");
    });

    API.bind("close:finish", function() {
        $button.removeClass("is-active");
    });

    new links();

    $('a.share').click(function(event) {
        new sharepopup($(this).attr('href'));
        event.preventDefault();
    });
});

$(window).on('load', function() {
    (function(d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.src = "//connect.facebook.net/en_US/all.js#xfbml=1";
        fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
});
